import { Component, OnInit } from '@angular/core';
import { GetReadyNavigationFullService } from '../../shared/get-ready-navigation.service';

import { GetReadyCommonFullService } from '../../shared/get-ready-common.service';
import { AdminListEnum } from '../../../shared/services/admin-lists/enum/admin-list.enum';

@Component({
  selector: 'error-page-solicitation',
  templateUrl: './error-page-solicitation.component.html',
  styleUrls: ['../shared/errors-style.scss', './error-page-solicitation.component.scss']
})
export class ErrorPageSolicitationFullComponent implements OnInit {

  pageId: string;
  phone: number;
  urlOCA: string;

  constructor(
    public navigationService: GetReadyNavigationFullService,
    private getReadyCommonService: GetReadyCommonFullService
  ) {}

  ngOnInit() {
    const adminLinkURLs = this.getReadyCommonService.getAdminList(AdminListEnum.LIST_URLS);

    this.pageId = 'error_page_solicitation';
    this.phone = 1730;
    this.urlOCA = adminLinkURLs.find(i => i.code.toUpperCase() === 'INSTITUTIONAL_SITE').description;
  }

}
